export default __webpack_public_path__ + "static/media/Bindings of Black Oblivion.5b7df60a.jpg";